import { healthieFormSchema } from "@/features/intake-form/models";
import { parseResponseData, publicAPI } from "@/shared/lib";

interface GetIntakeFormByBmiParams {
  bmi: number;
  state?: string;
}

export const getIntakeFormByBmi = async ({
  bmi,
  state,
}: GetIntakeFormByBmiParams) => {
  const response = await publicAPI.post("/onboarding/intake-form", {
    bmi,
    ...(state && { state }),
  });

  return parseResponseData(response, healthieFormSchema);
};
